import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Flex, Radio } from 'antd';

import { setUserTableSettings } from '../../redux/actions/user';

import MultiSelectDropdown from '../../views/ui-components/MultiSelectDropdown';

import { TABLE_SIZE } from './constants';

function AppTableSettings({ className, columns = [], tableId, choseVisibleColumns, handleResetSettings }) {
  const dispatch = useDispatch();

  const { tableSettings } = useSelector(state => state.user);
  const [size, setSize] = useState(tableSettings?.size);

  function choseTableSize(size) {
    setSize(size);
    dispatch(setUserTableSettings({ size }));
  }

  return (
    <Flex wrap justify="end" gap="small" className={className}>
      <Radio.Group
        buttonStyle="solid"
        className="custom-radio-group d-flex flex-nowrap"
        optionType="button"
        value={size}
        onChange={({ target }) => choseTableSize(target.value)}>
        <Radio.Button value={TABLE_SIZE.SM}>Small</Radio.Button>
        <Radio.Button value={TABLE_SIZE.MD}>Medium</Radio.Button>
        <Radio.Button value={TABLE_SIZE.LG}>Large</Radio.Button>
      </Radio.Group>

      <MultiSelectDropdown
        columns={columns}
        onChange={choseVisibleColumns}
        tableId={tableId}
        handleReset={tableId ? handleResetSettings : null}
      />
    </Flex>
  );
}

export default memo(AppTableSettings);
